module.exports = __webpack_public_path__ + "static/img/knowledge.709d097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knowledge.jpg
// module id = IH66
// module chunks = 0